module.exports = __webpack_public_path__ + "ar.no1.309e46a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ar.no1.jpg
// module id = /yTo
// module chunks = 0